import { SPACE_DEATILS_ACTION } from 'core/constants/Actions'
import { Action } from 'core/models/ActionTypes'
import { Space } from 'core/models/Space'

const intialState: { space: Space | null, isLoading: boolean } = {
  space: null,
  isLoading: false
}

interface ActionType extends Action {
  payload: {
    space: Space;
  }
}

export default function spaceDetailsReducer(state = intialState, action: ActionType) {

  switch (action.type) {
    case SPACE_DEATILS_ACTION.REQUEST:
      return { ...state, isLoading: true }

    case SPACE_DEATILS_ACTION.SUCCESS:
      const { space } = action.payload;
      return { ...state, space, isLoading: false }

    case SPACE_DEATILS_ACTION.FAILURE:
      return { ...state, ...intialState }

    default:
      return state
  }
}